export default "__VITE_ASSET__64f6e966__"